import apiClient from '@/plugins/axios';

export default {
	getFloors(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value || value === false ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/Floor${query}`);
	},

	getFloor(floorId) {
		return apiClient.get(`v1/Floor/${floorId}`);
	},

	createFloor(floor) {
		return apiClient.post('v1/Floor', floor);
	},

	updateFloor(floor) {
		var floorId = floor.id;

		return apiClient.put(`v1/Floor/${floorId}`, floor);
	},

	deleteFloor(floorId) {
		return apiClient.delete(`v1/Floor/${floorId}`);
	}
};
